import { atom } from "jotai";

interface GroupInfo{
    parentID?:string;
    childID?:string;
}
const SELECTED_GROUP_INFO:GroupInfo = {}

export const selectedGroupAtom = atom<GroupInfo>(SELECTED_GROUP_INFO);